import { render, staticRenderFns } from "./IV05.vue?vue&type=template&id=4ca62d91"
import script from "./IV05.vue?vue&type=script&lang=js"
export * from "./IV05.vue?vue&type=script&lang=js"
import style0 from "./IV05.vue?vue&type=style&index=0&id=4ca62d91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports